import { AccountClassificationType, ModuleAccessConfiguration } from './SoftwareModuleAccessConfig.type';

export enum Feature {
  completedItemsLookback = 'completed_items_lookback',
  feedbackLookback = 'feedback_lookback',
  goals = 'goals',
  groupWorkspaces = 'group_workspaces',
  performanceReviews = 'performance_reviews',
  privateNotes = 'private_notes',
  projectManagementIntegrations = 'project_management_integrations',
  reviews = 'reviews',
  workspaceExport = 'workspace_export',
  kudos = 'kudos',
  meetingBot = 'meeting_bot',
}

export enum BillingPlan {
  paidPlan = 'paid_plan',
  freeTrial = 'free_trial',
  trialExpired = 'trial_expired',
  freePlan = 'free_plan',
  paidPlanPaymentFailed = 'paid_plan_payment_failed',
  paidPlanPredictiveIndex = 'paid_plan_predictiveindex',
}

type PlatformFeatureStateType = {
  state:
    | BillingPlan.paidPlan
    | BillingPlan.freeTrial
    | BillingPlan.trialExpired
    | BillingPlan.freePlan
    | BillingPlan.paidPlanPaymentFailed
    | BillingPlan.paidPlanPredictiveIndex;
};

export enum UserManagedFeatureState {
  active = 'active',
  disabled = 'disabled',
}

type UserManagedFeatureStateType = {
  state: UserManagedFeatureState.active | UserManagedFeatureState.disabled;
};

export type PlatformFeatureNameType =
  | Feature.completedItemsLookback
  | Feature.feedbackLookback
  | Feature.goals
  | Feature.groupWorkspaces
  | Feature.performanceReviews
  | Feature.privateNotes
  | Feature.projectManagementIntegrations
  | Feature.reviews
  | Feature.workspaceExport;

export type UserManagedFeatureNameType = Feature.kudos | Feature.meetingBot;

export type Features = {
  [key in PlatformFeatureNameType]: PlatformFeatureStateType;
} & {
  [key in UserManagedFeatureNameType]: UserManagedFeatureStateType;
};

export type Organization = {
  id: string;
  slug: string;
  name: string;
  canonical_name: string;
  employer?: {
    id: number;
    global_id: string;
    name: string;
    isConsumer: boolean;
  };
  trialAlreadyBeenExtended: boolean;
  blankFeedbackTemplateInstructions: any;
  salesforce_organization_data_source?: string;
  salesforce_user_tags?: string;
  stripe_customer_id: string | null;
  features: Features;
  daysLeftInTrial: number;
  trialExpiredPlanOverride: string | null;
  billingVersion: number;
  magicOneOnOne: boolean;
  availableDomains: string[];
  billingState: string;
  seats: number;
  seatsToBillFor: number;
  hasJiraIntegration: boolean | null;
  hasSalesforceIntegration: boolean | null;
  hasHubspotIntegration: boolean;
  blockAllUserAccess: boolean;
  pi_allowed_domains?: string[]; // TODO: Audit for correctness, we use the camel_case converter
  pi_company_guid?: string; // TODO: Audit for correctness, we use the camel_case converter
  piCompanyGuid?: string;
  is_pi_demo_account?: boolean; // TODO: Audit for correctness, we use the camel_case converter
  billingContact?: {
    id: number;
    email: string;
    full_name: string;
  };

  /**
   * This Software Module Access Config will be empty for legacy charma customers
   * It should be synced and present for current PI customers
   */
  software_module_access_config?: {
    accountClassification: { classificationType: AccountClassificationType };
    softwareModuleAccessConfig: ModuleAccessConfiguration[];
  };
};
